var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnoucementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 168,
    viewBox: "0 0 210 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 168
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.61 0H0V167.56H209.61V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.15 109.43C147.99 106.28 146.83 103.12 145.69 99.97C144.16 95.73 142.65 91.48 141.13 87.23C140.4 85.21 139.67 83.19 138.96 81.21C139.31 80.93 139.5 80.74 139.73 80.6C144.17 78.03 146.83 74.16 147.83 69.18C148.55 65.59 147.86 62.18 146.58 58.73C143.99 51.74 135.8 46.65 128.22 48.22C127.49 48.37 127.02 48.3 126.71 47.43C125.3 43.43 123.79 39.46 122.35 35.47C120.86 31.36 119.41 27.23 117.94 23.11C116.44 18.91 115.04 14.66 113.4 10.51C112.48 8.17999 111.91 5.59999 109.1 4.39999C106.16 3.14999 102.27 4.60999 101.42 7.72999C100.19 12.25 99.27 16.85 97.52 21.24C95.02 27.56 91.65 33.34 87.4 38.61C81.58 45.83 74.53 51.65 66.73 56.62C59.22 61.43 51 64.6 42.71 67.64C39.13 68.95 35.54 70.21 31.95 71.5C29.62 72.34 27.28 73.15 24.96 74.04C21.58 75.33 18.09 76.41 14.9 78.06C6.73003 82.26 2.10003 89.2 0.41003 98.12C-0.26997 101.7 -0.0699705 105.27 0.760029 108.87C1.71003 113 3.37003 116.76 6.04003 119.99C13.17 128.63 22.38 132.05 33.41 130.25C35.02 129.99 35.69 130.39 36.27 131.63C36.34 131.79 36.48 131.91 36.58 132.06C39.75 136.85 42.92 141.65 46.1 146.44C49.77 151.97 53.34 157.57 57.16 163C60.39 167.59 65.36 168.27 69.96 166.96C71.91 166.41 73.76 165.54 75.69 164.92C80.67 163.34 84.07 158.13 83.5 152.93C83.22 150.37 81.96 148.3 80.56 146.22C76.57 140.33 65.08 122.87 63.18 120.03C63.55 119.81 63.69 119.7 63.86 119.64C68.99 117.69 74.15 115.79 79.57 114.78C83.77 113.99 87.98 113.06 92.22 112.78C99.7 112.28 107.19 112.36 114.61 113.92C119.57 114.96 124.39 116.42 129.01 118.48C134.51 120.95 139.6 124.14 144.22 128.02C146.73 130.13 149.56 129.56 151.4 128.5C153.48 127.3 154.52 124.17 153.64 121.63C152.2 117.54 150.64 113.5 149.15 109.43ZM140.79 62.83C142.23 67.86 140.14 72.49 136.48 74.41C134.13 67.9 131.78 61.41 129.41 54.87C134.77 54.31 139.23 57.37 140.79 62.83ZM34.39 123.02C28.01 124.96 21.92 123.99 16.32 120.3C11.64 117.21 8.70003 112.82 7.44003 107.45C6.90003 105.15 6.97003 102.66 7.11003 100.27C7.56003 92.57 12.04 87.47 18.39 83.86C20.87 82.45 23.69 81.62 26.39 80.61C29.21 79.56 32.08 78.63 34.93 77.62C38.88 76.22 42.82 74.8 46.9 73.34C51.71 86.64 56.53 99.94 61.34 113.22C56.7 114.93 52.28 116.57 47.84 118.19C43.36 119.82 38.94 121.63 34.39 123.02ZM65.49 136C65.87 136.35 67.61 139.06 67.61 139.06L69.27 141.78C67.11 142.94 65.98 144.9 66.66 146.66C67.46 148.71 69.01 149.44 71.28 148.83C72.06 148.62 73.47 147.97 73.47 147.97C73.47 147.97 76.66 152.64 76.62 154.15C76.56 156.44 75.49 157.58 73.44 158.45C71.66 159.21 69.77 159.71 67.95 160.38C65.46 161.31 63.49 160.42 62.1 158.34C55.83 148.89 49.6 139.41 43.36 129.94C42.9 129.24 42.41 128.56 41.77 127.64C46.68 125.86 51.47 124.12 56.43 122.32C58.19 124.98 59.98 127.68 61.69 130.26C60.63 131.01 59.53 131.52 58.84 132.36C57.84 133.56 58.03 135.24 58.97 136.44C59.78 137.47 61.36 137.94 62.72 137.56C62.83 137.52 65.49 136 65.49 136ZM139.69 116.47C135.5 113.92 131.14 111.71 126.45 110.25C122.98 109.17 119.52 108 115.97 107.29C107.62 105.61 99.18 105.07 90.68 106.15C87.37 106.57 84.02 106.81 80.76 107.48C76.6 108.35 72.52 109.57 68.4 110.64C68.23 110.68 68.05 110.71 67.76 110.76C62.98 97.56 58.2 84.36 53.4 71.12C79.8 59.84 99.51 42.54 107.18 13.71C120.08 49.3 132.91 84.71 145.86 120.47C143.59 118.99 141.67 117.68 139.69 116.47Z",
    fill: "#FB9843"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 168
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.61 0H0V167.56H209.61V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.27 48.15C207.38 43.23 205.77 38.49 203.71 33.89C199.61 24.72 193.62 17.04 185.91 10.68C180.47 6.19 174.35 2.84 167.76 0.330001C165.49 -0.539999 163.63 0.420001 162.73 2.23C161.72 4.24 162.71 6.39 164.9 7.34C165.91 7.78 166.94 8.2 167.94 8.66C175.14 11.96 181.66 16.15 187 22.16C193.78 29.8 198.38 38.48 200.49 48.47C201.52 53.37 202.2 58.32 201.66 63.33C201.3 66.65 201.05 70.01 200.24 73.23C199.36 76.73 197.92 80.1 196.65 83.49C195.9 85.5 196.62 87.49 198.57 88.37C200.49 89.24 202.92 88.51 203.66 86.59C204.95 83.26 206.13 79.88 207.2 76.46C208.84 71.23 209.45 65.85 209.62 60.35C209.18 56.28 209 52.16 208.27 48.15Z",
    fill: "#FB9843"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 168
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.61 0H0V167.56H209.61V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.57 41.87C180.6 35.5 176.17 30.33 170.8 25.95C167.21 23.02 163.18 20.73 158.89 18.9C156.64 17.94 154.55 19.04 153.78 20.64C152.74 22.79 153.55 24.83 155.71 25.81C159.27 27.44 162.73 29.24 165.83 31.68C170.49 35.35 174.14 39.84 176.71 45.2C178.77 49.49 179.94 54.03 180.27 58.77C180.66 64.45 179.69 69.94 177.86 75.31C177.49 76.38 177.11 77.5 177.04 78.62C176.93 80.29 178.26 81.86 179.71 82.1C181.74 82.44 183.58 81.56 184.24 79.9C186.65 73.9 187.96 67.68 188.01 60.16C187.88 58.75 187.79 56.29 187.38 53.88C186.66 49.71 185.37 45.73 183.57 41.87Z",
    fill: "#FB9843"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 168
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.61 0H0V167.56H209.61V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.22 38.31C148.29 37.41 145.99 38.13 145.15 40.1C144.38 41.9 144.67 44 146.9 45.17C148.68 46.1 150.48 47.09 152.04 48.34C156.19 51.66 158.44 56.01 158.56 61.41C158.62 64.08 158.01 66.6 157.17 69.1C156.47 71.18 157.03 73.27 159.26 74.12C161.2 74.86 163.4 74.02 164.15 72.21C165.53 68.88 166.02 65.38 166.21 62.05C166.1 57.36 165.21 53.1 162.86 49.26C159.81 44.29 155.48 40.75 150.22 38.31Z",
    fill: "#FB9843"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209.61,
    height: 167.56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnoucementIcon);
export default __webpack_public_path__ + "static/media/annoucement-icon.6058e023b7b2e27d3bb0c6e9ce075b3b.svg";
export { ForwardRef as ReactComponent };